import type { PlatformGift, UserGift } from "@/shared/api/types"

/**
 * Adapt a marketplace `PlatformGift` to the `UserGift` shape expected by
 * `GiftDetailsSheet` (image, name, attributes, price pill). The price pill maps
 * to `purchase_price_nano_ton` — that's what the user is about to pay.
 * Withdrawal-related fields are inert since the marketplace flow only buys.
 */
export function platformGiftToUserGift(g: PlatformGift): UserGift {
  return {
    id: g.id,
    slug: g.slug,
    num: g.num ?? null,
    assessed_price_nano: g.purchase_price_nano_ton,
    status: "AVAILABLE",
    withdrawable_at: null,
    available_for_bet: false,
    attributes: g.attributes,
    collection: g.collection,
    model: g.model,
    background: g.background ?? null,
    symbol: g.symbol ?? null,
    large_image_url: g.large_image_url,
    small_image_url: g.small_image_url,
    gift_address: g.gift_address ?? null,
    transfer_stars: g.transfer_stars ?? null,
    withdrawal_fee_nano_ton: null,
    withdrawal_available: false,
    withdrawal_unavailable_reason: null,
    availability_issued: g.availability_issued ?? null,
    availability_total: g.availability_total ?? null,
    created_at: 0,
  }
}
